const defaultState = {
	//Basic
	defaultPlant: 'HVS1',
	commCdType: '',
	commCdList: '',
	currentPage: '0',
	pageUnit: '10',

	//Main
	controlScrId: '',
	controlScrName: '',
	userId: '',
	onlyIng: '',

	ControlList: [],
	plants: [],
	controlScrIds: [],
	selection: [],

	searchParams: {
		plantCd: 'HVS1',
		controlScrId: '',
		controlScrName: '',
		userId: '',
		onlyIng: ''
	},
	groups: {
		currentPage: 0,
		pageUnit: 10,
		totalSize: 0,
		data: []
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
